<template>
    <div>
        <masternav/>
        <!--  -->
      
      <b-nav class="navlinks ">
        <b-nav-item router-link :to="{ name: 'Home'}">
          <span class="navtext ">{{$t('cookie.nav1')}}</span>
        </b-nav-item>
          <span class="mt-2 text-secondary">/</span>
        <b-nav-item disabled>
            <span class="navtext2">{{$t('cookie.nav2')}}</span>
        </b-nav-item>
      </b-nav>
      <!--  -->
      <div class="m-5">
        <h1 class="titlequestion ml-5 mr-5 ">{{$t('cookie.cook1')}}</h1>
        <br><br>
        <div class="ml-5 mr-5 navtext2 ">
          <p class="titleterm "></p>
          <h6>
            {{$t('cookie.cook2')}}</h6>
          <!--  -->
          <p class="titleterm ">{{$t('cookie.cook3')}}</p>
          <h6>
             {{$t('cookie.cook4')}}</h6>
          <!--  -->
          <p class="titleterm ">{{$t('cookie.cook5')}}</p>
          <h6>
              {{$t('cookie.cook6')}}</h6>
        </div>
        <br><br>
       </div>  
      <!--  -->
        <mainfooter/>
    </div>
</template>

<script>
import masternav      from '@/components/masternav.vue'
import maincontent    from '@/components/maincontent.vue'
import mainfooter     from '@/components/mainfooter.vue'
import rents          from '@/components/rents.vue'
import covidnews      from '@/components/covidnews.vue'

export default {
    name: 'Cookies',
    components: {
        masternav,
        mainfooter,
        maincontent,
        rents,
        covidnews
    }
}
</script>

<style lang="scss" scoped>
.titlequestion{
   font-family: 'DIN 2014-ExraBold', Arial, sans-serif;
   font-size: 32px;
   margin-top: 15px;
   margin-left: 30px;
   font-weight: 800;
   color: #181918;
}
.navtext{
    font-family: 'DIN 2014-Regular', Arial, sans-serif;
    color: #169a5a !important;
    font-size: 14px;
    font-weight: 300;
}
.titleterm{
   font-family: 'DIN 2014-ExraBold', Arial, sans-serif;
   font-size: 18px;
   margin-top: 15px;
   margin-left: 0px;
   font-weight: 500;
   color: #333333;
}
.navtext2{
    font-family: 'DIN 2014-Regular', Arial, sans-serif;
    color: #686e6b !important;
    font-size: 14px;
    font-weight: 300;
}
</style>